import { render, staticRenderFns } from "./clearanceOfGoods.vue?vue&type=template&id=9f965c08&scoped=true&"
import script from "./clearanceOfGoods.vue?vue&type=script&lang=js&"
export * from "./clearanceOfGoods.vue?vue&type=script&lang=js&"
import style0 from "./clearanceOfGoods.vue?vue&type=style&index=0&id=9f965c08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f965c08",
  null
  
)

export default component.exports